export default __webpack_public_path__ + "static/media/rudi_thin.daa1cb50.otf";